import React, { ReactElement } from 'react'
import { useColor } from '../../../theme'
import { RunningTextLabel } from '../../RunningTextLabel'
import { TTableCell } from '../types'

export const runningTextCell: (
  isSecondaryText?: boolean,
) => TTableCell<string> =
  (isSecondaryText) =>
  (message): ReactElement => {
    const mainColor = useColor({ nuance: 5, palette: 'text' })
    const secondaryColor = useColor({ nuance: 2, palette: 'text' })

    return (
      <RunningTextLabel
        color={isSecondaryText ? secondaryColor : mainColor}
        fontSize={isSecondaryText ? 'sm' : 'auto'}
        letterSpacing={isSecondaryText ? '0.02em' : 'auto'}>
        {message}
      </RunningTextLabel>
    )
  }
